import React, { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactDatePicker from "../../common/ReactDatePicker";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../../utility";
import Loader from "../../common/Loader";

const ViewUser = () => {
    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);

    const [loading, setLoading] = useState(true);
    const [staffList, setStaffList] = useState([]);

    const navigate = useNavigate();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const { id } = useParams();

    const [user, setUser] = useState(null);
    const [data, setData] = useState(null);
    const [flag, setFlag] = useState(2);


    useEffect(() => {
        const token = localStorage.getItem("admin_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/admin/users/${id}`, { headers: { 'Authorization': `Bearer ${token}` } }).then((res) => {
            // console.log("View User res : ", res);
            setUser(res?.data?.user);
            setData(res?.data?.billInfo);
            setLoading(false);
        }).catch((err) => {
            // console.log("View User error : ", err);
            setLoading(false);
        })
    }, [flag])

    useEffect(() => {
        const token = localStorage.getItem("admin_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/admin/users/${id}/staffs`, { headers: { 'Authorization': `Bearer ${token}` } }).then((res) => {
            // console.log("Staff list res : ", res);
            setStaffList(res?.data?.staffList);
        }).catch((err) => {
            setLoading(false);
            // console.log("staff list error : ", err);
        })
    }, [flag])

    if (loading) {
        return (
            <Loader />
        )
    } else {
        return (
            <div className="staff-detail-page">
                <h1 className="staffName mt-3">{user?.user_account}</h1>
                <h6 className="breadCrumbs mt-4 pb-3">
                    <span className="pointer" onClick={() => navigate('/users')}>
                        User
                    </span>
                    <span className="greater-than"> &#62; </span>
                    <span className="viewUserText">{user?.user_account}</span>
                </h6>

                <h3 className="staffdetail-sub-heading mt-4 mb-0">Information</h3>
                <div className="d-flex pt-3">
                    <div className="div1 d-flex flex-column">

                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">User account</p>
                            <p className="displayBlockText fw-bold">{user?.user_account}</p>
                        </div>

                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">VCard</p>
                            <p className="displayBlockText fw-bold">{user?.vCard}</p>
                        </div>

                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Status</p>
                            {user?.status === 1 ? (
                                <p className="displayBlockText fw-bold color-42c78f">Enable</p>
                            ) : (
                                <p className="displayBlockText fw-bold text-danger">Disable</p>
                            )}
                        </div>

                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Wallet</p>
                            <p className="displayBlockText fw-bold">{user?.wallet ? Number(Number(user?.wallet).toFixed(2)).toLocaleString() : 0}</p>
                        </div>

                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Name - Surname</p>
                            <p className="displayBlockText fw-bold">{user?.name} {user?.surename}</p>
                        </div>

                        <div className="d-flex flex-row align-items-start">
                            <p className="displayBlockText">Address</p>
                            <p className="displayBlockText fw-bold">{user?.address}</p>
                        </div>

                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Email</p>
                            <p className="displayBlockText fw-bold">{user?.email}</p>
                        </div>

                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Phone</p>
                            <p className="displayBlockText fw-bold">{user?.phone_number}</p>
                        </div>

                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Company</p>
                            <p className="displayBlockText fw-bold">{user?.company}</p>
                        </div>

                    </div>
                </div>

                <h3 className="staffdetail-sub-heading mt-4 mb-0">User Details</h3>
                <div className="d-flex pt-3">
                    <div className="div1">

                        <div className="d-flex flex-row align-items-center pt-2 pb-2">
                            <p className="displayBlockText">Number Of VCard ({staffList?.length ? staffList?.length : 0})</p>
                            <button className="pointerButton w-100 ms-4" onClick={() => navigate(`/users/staff-list/${user?.user_account}/${id}`)}>See VCard List</button>
                        </div>
                        <div className="d-flex flex-row align-items-center pt-2 pb-2">
                            <p className="displayBlockText">Buy Points Statement</p>
                            <button className="pointerButton w-100 ms-4 " onClick={() => navigate(`/users/buypointsstatement/${user?.user_account}/${id}`)}>View</button>
                        </div>
                    </div>
                </div>

                <h3 className="staffdetail-sub-heading mt-4 mb-0">Bill Information</h3>
                <div className="d-flex pt-3">
                    <div className="div1">
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Company</p>
                            <p className="displayBlockText fw-bold">{data?.company_name ? data?.company_name : 'N/A'}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Company Address</p>
                            <p className="displayBlockText fw-bold">{data?.company_address ? data?.company_address : 'N/A'}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Phone</p>
                            <p className="displayBlockText fw-bold">{data?.company_phone ? data?.company_phone : 'N/A'}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">TAX ID</p>
                            <p className="displayBlockText fw-bold">{data?.company_tax_id ? data?.company_tax_id : 'N/A'}</p>
                        </div>
                    </div>
                </div>

                <div className="mb-5 mt-4">
                    <button className="pointerButton ps-5 pe-5" onClick={() => navigate(`/users/edit/${id}`)}>Edit</button>
                </div>

                {/* model one  */}

                <Modal show={show} onHide={handleClose} size="lg">
                    <div className="verify-email-div">
                        <h1>Verify V-card</h1>
                        <p className="pt-4 mt-4 mb-4 pb-4">Please confirm verification. V card in <b>angleria_2539@gmail.com</b> within 24 hours</p>

                        <div className="text-center">
                            <button className="btn-3 btn-1 me-2" onClick={handleClose}>Send</button>
                            <button className="btn-2 ms-2" onClick={handleClose}>Cancel</button>
                        </div>

                    </div>
                </Modal>

                {/* model two  */}

                <Modal show={show2} onHide={handleClose2} size="lg">
                    <div className="verify-email-div">
                        <h1>Edit allocate fund</h1>
                        <div className="p-3">
                            <h3>Fund</h3>
                            <div className="mt-3">
                                <input type="text" className="form-control d-inline-block" style={{ width: 'calc(100% - 52px)' }} /> <label className="ms-2">THB</label>
                            </div>
                            <h3 className="mt-3">Automatic</h3>
                            <div className="mt-3">
                                <input className="p-2" type="radio" />
                                <label className="mx-2">Every</label>
                                <select className="form-control d-inline-block w-25">
                                    <option>Select Day</option>
                                </select>
                                <label className="mx-2">and time</label>
                                <input type="text" placeholder="9:00" className="form-control w-25 d-inline-block" />
                                <label className="ms-2">in week.</label>
                            </div>

                            <div className="d-flex justify-content-between mt-3">
                                <div className="w-25 bdr-t"></div>
                                <div className="w-15" style={{ width: '15%' }}><lable>Or</lable></div>
                                <div className="w-25 bdr-t"></div>
                            </div>

                            <div className="mt-3">
                                <input className="p-2" type="radio" />
                                <label className="mx-2">Every</label>
                                <select className="form-control d-inline-block w-25">
                                    <option>Select Day</option>
                                </select>
                                <label className="mx-2">and time</label>
                                <input type="text" placeholder="9:00" className="form-control w-25 d-inline-block" />
                                <label className="ms-2">in month.</label>
                            </div>

                            <h3 className="mt-3">Manual</h3>

                            <div className="mt-3">
                                <input className="p-2" type="radio" />
                                <div className="d-inline-block ms-2">
                                    <ReactDatePicker />
                                </div>
                                <label className="mx-2">and time</label>
                                <input type="text" placeholder="9:00" className="form-control w-25 d-inline-block" />
                                <label className="ms-2">in month.</label>
                            </div>
                        </div>
                        <div className="text-center mt-4">
                            <button className="btn-3 btn-1 me-2" onClick={handleClose2}>Send</button>
                            <button className="btn-2 ms-2" onClick={handleClose2}>Cancel</button>
                        </div>

                    </div>
                </Modal>

            </div>
        )
    }
}

export default ViewUser;